import { AgmMap } from '@agm/core';
import { Component, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-top-customer-locations',
  templateUrl: './top-customer-locations.component.html',
  styleUrls: ['./top-customer-locations.component.scss']
})
export class TopCustomerLocationsComponent{
  @ViewChild(AgmMap, { static: false }) agmMap!: AgmMap;

  // Example coordinates for the markers
  @Input() markers = [
  ];

  // Default zoom and center
  lat = 0;
  lng = 0;
  zoom = 10;

  // Called when the map is ready
  onMapReady(map: google.maps.Map) {
    this.setMapBounds(map);
  }

  // Fit the map bounds to show all markers
  setMapBounds(map: google.maps.Map) {
    if (this.markers.length === 0) return;

    // Create LatLngBounds object
    const bounds = new google.maps.LatLngBounds();

    // Extend the bounds with each marker's position
    this.markers.forEach(marker => {
      bounds.extend(new google.maps.LatLng(marker.lat, marker.lng));
    });

    // Fit the map to the bounds
    // map.fitBounds(bounds);
    setTimeout(() => {
      map.fitBounds(bounds);
    }, 200);
  }
}
